import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=fb8f47a6&scoped=true&"
import script from "./ClientDetails.vue?vue&type=script&lang=js&"
export * from "./ClientDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=fb8f47a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8f47a6",
  null
  
)

export default component.exports